import React from 'react';
import {Modal as AntdModal} from 'antd';
import SmallLogo from '../../assets/images/simple-logo.svg';

const Modal = ({
    title,
    visible,
    onOk,
    onCancel,
    customTitle = false,
    okText = 'Accept',
    cancelText = 'Decline',
    loading = {},
    ...props
}) => {
    return (
        <AntdModal
            centered={window.innerWidth > 1024}
            title={
                customTitle ? (
                    <div>{title}</div>
                ) : (
                    <div>
                        <img
                            src={SmallLogo}
                            style={{marginRight: 15, width: 35}}
                            alt="logo"
                        />
                        {title}
                    </div>
                )
            }
            visible={visible}
            closable={false}
            onCancel={onCancel}
            destroyOnClose
            cancelText={cancelText}
            okText={okText}
            onOk={onOk}
            wrapClassName="custom-modal"
            cancelButtonProps={{
                loading: loading?.cancelLoading,
                disabled: loading?.acceptLoading,
            }}
            okButtonProps={{
                loading: loading?.acceptLoading,
                disabled: loading?.cancelLoading,
            }}
            maskStyle={{
                backdropFilter: 'blur(6px)',
                background: '#fff0',
            }}
            {...props}
            data-testid="modal-1"
        >
            {props.children}
        </AntdModal>
    );
};
export default Modal;
